import React from "react";

import { ToastAccessory as ToastAccessoryProp } from "./types";

type IProps = {
  accessory?: ToastAccessoryProp;
};

export const ToastAccessory = ({ accessory }: IProps) => {
  if (accessory == null) {
    return null;
  }

  if (accessory.type === "icon") {
    const { Icon } = accessory;
    return (
      <div className="fs-toast__icon">
        <Icon color="inherit" titleAccess="" />
      </div>
    );
  }

  return (
    <img
      src={accessory.imageUrl}
      alt=""
      role="presentation"
      className="fs-toast__image"
    />
  );
};
